import { create } from 'zustand';

import { GetUbicacionesParams, getUbicaciones } from '@/shared/actions/erp';
import { Ubicaciones } from '@/shared/interfaces/erp/inventario';

interface UbicacionBodegaStore {

  //BODEGA ORIGEN
  ubicacionBodegas: Ubicaciones[];
  isLoadingUbicacionBodegas: boolean;
  getUbicacionBodega: (params?: GetUbicacionesParams) => Promise<void>;

  //BODEGA DESTINO
  ubicacionBodegasDestino: Ubicaciones[];
  isLoadingUbicacionBodegasDestino: boolean;
  getUbicacionBodegaDestino: (params?: GetUbicacionesParams) => Promise<void>;

  
}

export const useUbicacionBodegaStore = create<UbicacionBodegaStore>(set => ({
  ///* ubicacion origen
  ubicacionBodegas: [],
  isLoadingUbicacionBodegas: false,
  getUbicacionBodega: async params => {
    set({ isLoadingUbicacionBodegas: true });
    const { data } = await getUbicaciones(params);
    set({ ubicacionBodegas: data.data });
    set({ isLoadingUbicacionBodegas: false });
  },

  ///* ubicacion destino
  ubicacionBodegasDestino: [],
  isLoadingUbicacionBodegasDestino: false,
  getUbicacionBodegaDestino: async params => {
    set({ isLoadingUbicacionBodegasDestino: true });
    const { data } = await getUbicaciones(params);
    set({ ubicacionBodegasDestino: data.data });
    set({ isLoadingUbicacionBodegasDestino: false });
  },

  
}));
